<app-loading *ngIf="isLoading"></app-loading>

<app-layer-visualization-control [resultMode]="resultMode"></app-layer-visualization-control>